<script>
  import Select from 'svelte-select';
  import DatePicker from './Flatpickr/DatePicker.svelte';
  import { getUserInfo } from '../stores/auth';
  import SimpleFileUploader from '../components/SimpleFileUploader.svelte';
  let displayfiles = [];
  import DropDown from './DropDown.svelte';
  import AddTaskClient from './AddTaskClient.svelte';
  import SubTaskInput from './SubTaskInput.svelte';
  import FormInput from './FormControls/FormInput.svelte';
  import FormTextarea from './FormControls/FormTextarea.svelte';
  import TaskCollabrationHistory from './TaskDashboard/TaskCollabrationHistory.svelte';
  import TaskUpdateReason from './TaskDashboard/TaskUpdateReason.svelte';
  import { onMount, getContext, onDestroy } from 'svelte';
  import { client } from 'root/api/index.js';
  const taskAction = getContext('taskAction');
  import { createEventDispatcher } from 'svelte';
  import {
    customInputEvent,
    searchKeyByValue,
    validURL,
    setYupMessage,
    cloneArray,
    configItem,
    numberOnly,
    getTodayDate,
    addHttpIfNot,
    autogrowTextarea,
    removeAllTooltip,
    getValueBySearchValue,
    openStatusId,
    fileDownload,
  } from 'components/Helper.js';
  import { masterData, getMasterData } from '../stores/masterData.js';
  const dispatch = createEventDispatcher();
  import Loader from './Loader.svelte';
  import * as yup from 'yup';
  import { createForm } from 'svelte-forms-lib';
  let photoUrl =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcL_hveDzFBZFoTZ8qs902bi097hHDNIsfCg&usqp=CAU';
  import ProfileImg from './ProfileImage.svelte';
  import { flip } from 'svelte/animate';
  import * as bootstrap from 'bootstrap';

  export let id = 0;
  export let comeFrom = '';
  let newUrl = '';
  let newTitle = '';
  let units = [];
  const recurringTypes = configItem.recurringTypes;
  const customRecurringTypes = configItem.customRecurringTypes;
  let selectedRecurringType;
  let selectedTaskActivityTypeId;
  let selectedServiceTypeId;
  const cancelChanges = () => {
    show($form.id, comeFrom);
  };
  let submitViaReason = false;
  const handleReasonSubmit = () => {
    submitViaReason = true;
    handleSubmit();
  };

  const keyboardListnerStatus = getContext('keyboardListnerStatus');

  export const show = (id, oldComeFrom, extraFilter) => {
    keyboardListnerStatus(true);
    comeFrom = oldComeFrom;
    fetchDetail(id);
    if (extraFilter != undefined && extraFilter.unitId != undefined) {
      if (
        extraFilter.taskType != undefined &&
        extraFilter.taskType == 2 &&
        extraFilter.unitProjectId != undefined &&
        extraFilter.unitProjectId > 0
      ) {
        $form.taskType = extraFilter.taskType;
        $form.unitId = extraFilter.unitId;
        $form.unitProjectId = extraFilter.unitProjectId;
      } else if (extraFilter.clientId != undefined) {
        $form.unitId = extraFilter.unitId;
        selectedClients = [{ label: null, clientFundProfiles: null }];
        $form.clients = [{ id: extraFilter.clientId, clientFundProfiles: [] }];
      } else {
        if (extraFilter.clients.length > 0) {
          selectedClients = [];
          for (var i in extraFilter.clients) {
            selectedClients.push({
              label: null,
              clientFundProfiles: extraFilter.clients[i].clientFundProfiles,
            });
          }
        }
        $form = cloneArray(extraFilter);
      }
      selectedUnitId = units[searchKeyByValue(units, 'id', $form.unitId)];
      getUnitDetail();
    }
  };
  setYupMessage(yup);
  let templateSelected = false;
  const resetTemplateSelect = () => {
    fetchDetail(0);
  };
  let isAjaxLoading = false;
  export const onTemplateSelect = (templateId) => {
    templateSelected = true;
    isAjaxLoading = true;
    client
      .taskTemplateGet({ id: templateId })
      .then((response) => {
        let templateData = response.data;
        let copyData = {
          ...$form,
          taskTemplateId: templateId,
          unitProjectId: templateData.unitProjectId,
          name: templateData.name,
          purpose: templateData.purpose,
          requirement: templateData.requirement,
          description: templateData.description,
          requireReview: templateData.requireReview,
          responsibleParty: templateData.responsibleParty,
          recurring: templateData.recurring,
          attachments: templateData.attachments,
          recurringCustom: templateData.recurringCustom,
          recurringType: templateData.recurringType,
          recurringEvery: templateData.recurringType,
          urls: templateData.urls.map((item) => {
            item.taskTemplateId = item.id;
            delete item.id;
            return item;
          }),
          subTasks: templateData.subTaskTemplates.map((item) => {
            item.isNa = 0;
            item.taskTemplateId = item.id;
            delete item.id;
            return item;
          }),
          taskType: templateData.taskType,
        };
        $form = copyData;
        displayfiles = $form.attachments;
        if ($form.unitProjectId > 0) {
          selectedUnitProjectId = projects[searchKeyByValue(projects, 'id', $form.unitProjectId)];
        }
        isAjaxLoading = false;
        resetAutoGrow();
      })
      .catch((err) => {})
      .catch();
  };

  const resetAutoGrow = () => {
    setTimeout(() => {
      document.querySelectorAll('.sub-task-input').forEach(function (el) {
        autogrowTextarea(el);
      });
    }, 500);
  };

  let editTask = false;
  let taskNa = true;
  export let editSubTask = false;
  let openNotes = false;
  let user = { client: false };
  let unitUsers = [];
  let collabratorUser = [];
  function toggleUser() {
    user.client = !user.client;
  }

  function toggleTaskNa() {
    taskNa = !taskNa;
  }

  let clients = [];
  let projects = [];
  let clientFundProfiles = [];
  const getUnitAssignee = () => {
    let users = [...$form.users];
    users.push({ userId: $form.assigneeUserId });
    $form.subTasks.map((item) => {
      if (item.assigneeUserId != undefined && item.assigneeUserId > 0) {
        users.push({ userId: item.assigneeUserId });
      }
    });
    client
      .unitUsers({
        units: [{ unitId: $form.unitId }],
        clients: $form.clients,
        requireIds: users,
      })
      .then((response) => {
        let detail = response.data;
        unitUsers = detail.users;
        collabratorUser = detail.users;
        if ($form.assigneeUserId > 0) {
          selectedAssigneeUserId =
            unitUsers[searchKeyByValue(unitUsers, 'userId', $form.assigneeUserId)];
        }
        if ($form.collabratorUserId > 0) {
          selectedCollabratorUsers =
            unitUsers[searchKeyByValue(unitUsers, 'userId', $form.collabratorUserId)];
        }
        selectedUsers = [];
        if ($form.users != null && $form.users.length > 0) {
          let oldSelectedUsers = [];
          for (var i in $form.users) {
            var userKey = searchKeyByValue(collabratorUser, 'userId', $form.users[i].userId);
            collabratorUser[userKey].id = $form.users[i].id;
            oldSelectedUsers.push(collabratorUser[userKey]);
          }
          selectedUsers = oldSelectedUsers;
        }
        $form.subTasks.map((item) => {
          if (item.assigneeUserId != undefined && item.assigneeUserId > 0) {
            item.selectedAssigneeUserId =
              unitUsers[searchKeyByValue(unitUsers, 'userId', item.assigneeUserId)];
          }
        });
      });
  };
  let taskActivityTypes = [];
  const getTaskActivityType = () => {
    let params = {
      units: [{ id: $form.unitId }],
      taskActivityTypeIdRequired: $form.taskActivityTypeId,
    };
    client.getactivityTypes(params).then((response) => {
      taskActivityTypes = response.data.taskActivityTypes;
      selectedTaskActivityTypeId = null;

      if ($form.taskActivityTypeId > 0) {
        selectedTaskActivityTypeId =
          taskActivityTypes[searchKeyByValue(taskActivityTypes, 'id', $form.taskActivityTypeId)];
      }
    });
  };

  let taskServiceType = [];

  // Service type list in the Task Detail (Create / Edit mode)
  const assignServiceType = async () => {
    if (!$form.unitId) {
      selectedServiceTypeId = null;
      taskServiceType = [];
    }
    const result = await client.sowServiceType({ units: [{ id: $form.unitId }] });
    taskServiceType = result?.data?.payload || [];
    if ($form.taskServiceTypeId > 0) {
      selectedServiceTypeId =
        taskServiceType[searchKeyByValue(taskServiceType, 'id', $form.taskServiceTypeId)];
    }
  };

  const getUnitDetail = () => {
    getUnitAssignee();
    assignServiceType();
    getTaskActivityType();
    client
      .unitClients({
        units: [{ unitId: $form.unitId }],
        requireIds: $form.clients,
      })
      .then((response) => {
        clients = response.data.clients;
        clientFundProfiles = response.data.clientFundProfiles;
        if ($form.clients.length > 0) {
          let value = { label: null, clientFundProfiles: null };
          if (
            $form.clients[0]['clientFundProfiles'] != undefined &&
            $form.clients[0]['clientFundProfiles'][0] != undefined
          ) {
            value.clientFundProfiles = [
              clientFundProfiles[
                searchKeyByValue(
                  clientFundProfiles,
                  'id',
                  $form.clients[0]['clientFundProfiles'][0].id,
                )
              ],
            ];
          }
          value.label = clients[searchKeyByValue(clients, 'id', $form.clients[0].id)];
          selectedClients[0] = value;
        }
      });

    client
      .getUnitProject({
        units: [{ unitId: $form.unitId, id: $form.unitId }],
        requireId: $form.unitProjectId,
      })
      .then((response) => {
        projects = response.data.projects;
        if ($form.unitProjectId > 0) {
          selectedUnitProjectId = projects[searchKeyByValue(projects, 'id', $form.unitProjectId)];
        }
      });
  };
  let selectedUsers = [];

  let selectedClients = [
    {
      label: null,
      clientFundProfiles: null,
    },
  ];
  let selectedClientId;
  let selectedClientFundProfileId;
  let detail = {
    id: '',
    priority: '2',
    riskRank: 2,
    parentId: '',
    unitId: '',
    name: '',
    purpose: '',
    requirement: '',
    status: 1,
    complianceStatus: 2,
    description: '',
    clientNotes: '',
    taskType: 1,
    responsibleParty: 1,
    requireReview: 0,
    unitProjectId: '',
    recurring: 0,
    recurringType: '',
    recurringCustom: 0,
    recurringEvery: 1,
    assigneeUserId: '',
    collabratorRemove: 0,
    collabratorReviewStatus: '',
    collabratorUserId: '',
    collabratorSubmitNotes: '',
    collabratorReviewNotes: '',
    openDate: '',
    dueDate: '',
    initialBoardDate: '',
    taskTemplateId: '',
    clients: [],
    users: [],
    urls: [],
    attachments: [],
    subTasks: [],
    isNa: 0,
    updateReason: '',
    createdBy: '',
    completeDate: '',
    taskActivityTypeId: '',
    taskServiceTypeId: '',
  };

  // {
  //             "id": "",
  //             "clientFundProfiles": []
  //         }

  const showDialog = getContext('showDialog');
  let clientError = false;
  let isFormPending = false;
  let serverErrors = [];
  const { form, errors, state, handleChange, handleSubmit } = createForm({
    initialValues: { ...detail },
    validationSchema: yup.object().shape({
      unitId: yup.string().required(),
      assigneeUserId: yup.string().when('unitId', {
        is: (value) => {
          return !($form.parentId > 0);
        },
        then: yup.string().required(),
      }),
      name: yup.string().required(),
      purpose: yup.string().required(),
      requirement: yup.string(),
      description: yup.string().required(),
      clientNotes: yup.string(),
      responsibleParty: yup.string().when('taskType', {
        is: (value) => {
          return value == 1;
        },
        then: yup.string().test('responsibleParty', 'Required', function (value) {
          return value > 0;
        }),
      }),
      openDate: yup.string().required(),
      dueDate: yup.string().required(),
      collabratorReviewStatus: yup.string().nullable(),
      collabratorUserId: yup.string().when('collabratorReviewStatus', {
        is: (value) => {
          return value == 1;
        },
        then: yup.string().required().nullable(),
      }),
      recurringEvery: yup.number().when('recurring', {
        is: (value) => {
          return value == 1 && $form.recurringCustom == 1;
        },
        then: yup.number().required().min(1).max(50),
      }),
      recurringType: yup.string().when('recurring', {
        is: (value) => {
          return value == 1;
        },
        then: yup.string().required(),
      }),
      collabratorSubmitNotes: yup
        .string()
        .nullable()
        .when('collabratorReviewStatus', {
          is: (value) => {
            return value == 1 && editCollabrator.classList.contains('show');
          },
          then: yup.string().required(),
        }),
      collabratorReviewNotes: yup
        .string()
        .nullable()
        .when('collabratorReviewStatus', {
          is: (value) => {
            return value == 2 && reviewCollabrator.classList.contains('show');
          },
          then: yup.string().required(),
        }),
      updateReason: yup
        .string()
        .nullable()
        .when('assigneeUserId', {
          is: (value) => {
            return false;
            return (
              editTask &&
              ((oldTaskData.status == 1 && $form.status == 2) ||
                oldTaskData.assigneeUserId != $form.assigneeUserId ||
                oldTaskData.openDate != $form.openDate ||
                oldTaskData.dueDate != $form.dueDate)
            );
          },
          then: yup.string().required(),
        }),
      subTasks: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          name: yup.string().required(),
        }),
      ),
      taskActivityTypeId: yup.string().nullable(),
    }),
    onSubmit: (values) => {
      clientError = $form.taskType == 1 && $form.clients.length == 0;
      if (clientError) {
        return;
      }
      if (taskUpdateReason != undefined) {
        taskUpdateReason.hide();
      }
      isFormPending = true;
      client
        .taskSave({
          ...values,
          comeFrom,
        })
        .then((arr) => {
          if (id > 0 && values.status != 2) {
            cancelChanges();
          }
          //
          // if(submitViaReason){
          //   submitViaReason=false
          //   return cancelChanges()
          // }
          isFormPending = false;
          taskAction({
            type: 'saveTask',
            id: id,
            values: values,
          });
          // id=""
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
          showDialog({ message: serverErrors });
        });
    },
  });

  let prevTaskId = 0;
  let nextTaskId = 0;
  let addClientlabel = null;
  export let setTaskData = (item) => {};
  const resetTask = () => {
    // selectedClients=[{
    //     "label": null,
    //     "clientFundProfiles": null
    // }]
    addClientlabel = null;
    selectedClients = [];
    selectedUnitId = null;
    selectedClientFundProfileId = null;
    selectedClientId = null;
    selectedUnitProjectId = null;
    selectedCollabratorUsers = null;
    selectedTaskActivityTypeId = null;
    selectedServiceTypeId = null;
    selectedAssigneeUserId = null;
    selectedRecurringType = null;
    selectedStatus = null;
    selectComplianceStatus = null;
    editSubTask = false;
    templateSelected = false;
    prevTaskId = 0;
    nextTaskId = 0;
    taskCompleted = false;
    displayfiles = [];
    clients = [];
    projects = [];
    clientFundProfiles = [];
    unitUsers = [];
    collabratorUser = [];
    $form = cloneArray(detail);
    $errors = {};
  };
  let parentTask;
  let oldCollabratorReviewStatus = '';
  let oldTaskData = {};
  let taskCompleted = false;
  let taskLoaded = true;
  const fetchDetail = (requestId) => {
    id = requestId != undefined ? requestId : 0;
    editTask = id > 0;
    resetTask();
    if (id > 0) {
      isFormPending = true;
      taskLoaded = false;
      client
        .taskGet({ id: id })
        .then((response) => {
          taskLoaded = true;
          isFormPending = false;
          selectedClients = [
            {
              label: null,
              clientFundProfiles: null,
            },
          ];
          taskCompleted = response.data.status == 2;
          if (comeFrom != undefined && comeFrom == 'clone') {
            id = 0;
            templateSelected = false;
          } else {
            templateSelected = response.data.taskTemplateId > 0 || response.data.status == 2;
          }

          oldCollabratorReviewStatus = response.data.collabratorReviewStatus;
          oldTaskData = cloneArray(response.data);
          $form = response.data;
          displayfiles = $form.attachments;
          editSubTask = response.data.parentId > 0;
          nextTaskId = response.data.nextTaskId;
          prevTaskId = response.data.prevTaskId;
          parentTask = response.data.parentTask;
          selectComplianceStatus = configItem.allComplianceStatus.find(
            (item) => item.id === response.data.complianceStatus,
          );
          selectedUnitId = units[searchKeyByValue(units, 'id', $form.unitId)];
          selectedRecurringType =
            customRecurringTypes[searchKeyByValue(customRecurringTypes, 'id', $form.recurringType)];
          if (
            /*$form.requireReview==1 &&*/ openStatusId.includes($form.status) &&
            editSubTask == false
          ) {
            if ($form.collabratorReviewStatus == 0) {
              status = [
                ...defaultStatus,
                // Bump id number outside the status id range (from 1 to 14)
                { id: 15, text: 'Submit to collaborator' },
              ];
              selectedStatus = status[searchKeyByValue(status, 'id', $form.status)];
            } else if ($form.collabratorReviewStatus == 1) {
              selectedStatus = {
                // Bump id number outside the status id range (from 1 to 14)
                id: 15,
                text: 'Submit to collaborator',
              };
              if ($form.collabratorUserId == getUserInfo().id) {
                status = [
                  ...defaultStatus,
                  // Bump id number outside the status id range (from 1 to 14)
                  { id: 16, text: 'Review Completed' },
                ];
              }
            } else if ($form.collabratorReviewStatus == 2) {
              // selectedStatus={ id: 4, text: 'Review Completed'}
              // if($form.collabratorUserId==getUserInfo().id){
              selectedStatus = status[searchKeyByValue(status, 'id', $form.status)];
              status = [
                ...defaultStatus,
                // Bump id number outside the status id range (from 1 to 14)
                { id: 15, text: 'Submit to collaborator' },
              ];
              // }
            } else {
              selectedStatus = status[searchKeyByValue(status, 'id', $form.status)];
            }
          } else {
            status = [...defaultStatus];
            selectedStatus = status[searchKeyByValue(status, 'id', $form.status)];
          }
          setTaskData($form);
          getUnitDetail();
          setTimeout(() => {
            initPopupOver();
          }, 400);
          resetAutoGrow();
        })
        .catch((err) => {
          if (typeof err != 'undefined') {
            showDialog({ message: [err] });
            setTimeout(() => {
              taskAction({
                type: 'taskDeleted',
              });
            }, 1000);
          }
        });
    }
  };

  let showDeleteTask = true;
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        units = getMasterData().units;
        let userRoleId = getUserInfo().roleId;
        let userRoles = getMasterData().userRoleId;
        // showDeleteTask=(userRoles.admin == userRoleId || userRoles.unit_admin == userRoleId)
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
  });

  function toggleNotes() {
    openNotes = !openNotes;
  }

  let recurring = false;
  let isCustom = false;
  function chekBoxInput() {
    recurring = !recurring;
  }
  function Recurring() {
    isCustom = !isCustom;
  }

  const addSubTask = () => {
    let oldSubTasks = $form.subTasks;
    if (oldSubTasks.length > 0 && oldSubTasks[oldSubTasks.length - 1].name.trim() == '') {
      // return false;
    }
    oldSubTasks = oldSubTasks.map((item) => {
      item.autoFocus = false;
      item.name = item.name.trim();
      return item;
    });
    oldSubTasks.push({
      name: '',
      autoFocus: true,
      isNa: 0,
      status: 1,
      assigneeUserId: null,
      selectedAssigneeUserId: null,
    });
    $form.subTasks = oldSubTasks;
    setTimeout(() => {
      const items = [...document.getElementsByClassName('sub-task-input')];
      items[$form.subTasks.length - 1].focus();
      initPopupOver();
    }, 100);
  };

  const complexItems = [
    { value: 'john', label: 'John', group: 'Sweet' },
    { value: 'smith', label: 'Smith', group: 'Savory' },
    { value: 'anis', label: 'Anis', group: 'Sweet' },
    { value: 'sumit', label: 'Sumit', group: 'Savory' },
    { value: 'ellesh', label: 'Ellesh', group: 'Sweet' },
  ];

  let defaultStatus = configItem.allTaskStatus
    .filter((item) => item.id !== 3)
    .map((item) => ({ ...item, text: item.name }))
    .sort((a, b) => a.id - b.id);

  let status = [
    { id: 1, text: 'Open' },
    { id: 2, text: 'Complete' },
  ];

  let date = [
    { id: 1, text: '1' },
    { id: 2, text: '2' },
    { id: 3, text: '3' },
    { id: 4, text: '5' },
    { id: 5, text: '6' },
  ];

  const businessUnit = ['US Compliances', 'UK Compliances', 'Outsourced CFO', 'Fund Admin'];

  const assigneeUser = ['John Smith', 'Rean', 'Roa', 'Ciya'];
  let selectedUnitId;
  let selectedAssigneeUserId;
  let selectedStatus;
  let selectComplianceStatus;
  let selectedUnitProjectId;
  let selectedCollabratorUsers;
  export let selectFromTemplate;
  let urlInvalid = '';
  let taskCollabrationHistory;
  let taskUpdateReason;
  const addUrl = () => {
    if (newUrl != '') {
      if (validURL(newUrl)) {
        let oldUrls = $form.urls;
        oldUrls.push({ title: newTitle, url: addHttpIfNot(newUrl) });
        $form.urls = oldUrls;
        newUrl = '';
        newTitle = '';
        urlInvalid = false;
      } else {
        urlInvalid = 'Invalid Url';
      }
    } else {
      urlInvalid = 'Required';
    }
  };

  const addClient = () => {
    if (addClientlabel) {
      let oldClients = $form.clients;
      if (searchKeyByValue(oldClients, 'id', addClientlabel.id) !== -1) {
        showDialog({ message: 'Client already selected' });
      } else {
        selectedClients.push({
          label: addClientlabel,
          clientFundProfiles: null,
        });
        oldClients.push({
          id: addClientlabel.id,
          clientFundProfiles: [],
        });
        $form.clients = oldClients;
        addClientlabel = null;
        clientError = false;
        getUnitAssignee();
      }
    } else {
      showDialog({ message: 'Please select clients' });
    }
  };

  let hovering = false;
  const drop = (event, target) => {
    event.dataTransfer.dropEffect = 'move';
    const start = parseInt(event.dataTransfer.getData('text/plain'));
    const newTracklist = $form.subTasks;

    if (start < target) {
      newTracklist.splice(target + 1, 0, newTracklist[start]);
      newTracklist.splice(start, 1);
    } else {
      newTracklist.splice(target, 0, newTracklist[start]);
      newTracklist.splice(start + 1, 1);
    }
    $form.subTasks = newTracklist;
    hovering = null;
  };
  const dragstart = (event, i) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.dropEffect = 'move';
    const start = i;
    event.dataTransfer.setData('text/plain', start);
  };
  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      el.remove();
    });
    var elements = document.querySelectorAll('.subtask_popover');
    elements.forEach(function (el) {
      new bootstrap.Popover(el, {
        container: el.parentElement,
        animation: false,
      });
    });
  };

  let selectedUserLabel;

  const getResposiblePartyLabel = (flag, form) => {
    if (flag == 'unit') {
      if (selectedUnitId) {
        return selectedUnitId.responsible_party_name;
      } else {
        return 'Us';
      }
    } else {
      let key = 0;
      if (selectedClients.length > 0 && selectedClients[key].label) {
        return selectedClients[key].label.name;
      } else {
        return 'Client';
      }
    }
  };
</script>

<div class="page-content">
  {#if taskLoaded}
    <form
      action="#"
      on:submit={(e) => {
        e.stopImmediatePropagation();
        return false;
      }}
    >
      {#if $form.parentId != undefined && $form.parentId > 0}
        <div class="form-slect-comp d-flex justify-content-between w-100">
          <div>
            <button
              type="button"
              disabled={parentTask.isEditable == false}
              on:click={() => show($form.parentTask.id)}
              class="btn btn-link text-blue mb-0 p-0 font-size-16 font-weight-600"
              >Main Task: {$form.parentTask.name}</button
            >
          </div>
        </div>
        <div class="form-slect-comp d-flex justify-content-between w-100 pt-0">
          <div>
            {#if prevTaskId > 0}
              <button
                type="button"
                on:click={() => show(prevTaskId)}
                class="btn btn-link bg-transparent color-blue font-size-12 p-0 shadow-none"
              >
                <img
                  alt=""
                  class="icon-16 me-1"
                  src="/images/chevron-back.svg"
                />
                Prev</button
              >
            {/if}
          </div>
          <div class="text-right">
            {#if nextTaskId > 0}
              <button
                type="button"
                on:click={() => show(nextTaskId)}
                class="btn btn-link bg-transparent color-blue font-size-12 shadow-none p-0"
              >
                <span>Next</span>
                <img
                  alt=""
                  class="icon-16 me-1 icon-next"
                  src="/images/chevron-back.svg"
                />
              </button>
            {/if}
          </div>
        </div>
      {/if}

      <div class="form-slect-comp form-input-area">
        <div class="d-flex flex-row justify-content-between align-items-center">
          <div class="d-flex flex-row justify-content-between w-100">
            <div class="d-flex flex-row justify-content-start w-100">
              <div
                class="form-group select-block select-client-type me-1 business-template position-relative {$errors.unitId
                  ? 'error'
                  : ''}"
              >
                <Select
                  showChevron={true}
                  isClearable={false}
                  isDisabled={id > 0 || comeFrom == 'assignTask'}
                  bind:selectedValue={selectedUnitId}
                  items={units}
                  placeholder="Select Business Unit"
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  containerClasses="form-control"
                  on:select={(ev) => {
                    if (
                      /*templateSelected &&*/ $form.unitId != '' &&
                      ev.detail.id != $form.unitId
                    ) {
                      showDialog({
                        type: 'confirm',
                        title: '',
                        message:
                          'Changing business unit will reset all data you have filled so far',
                        okFunc: () => {
                          resetTemplateSelect();
                          $form.unitId = ev.detail.id;
                          selectedUnitId = units[searchKeyByValue(units, 'id', $form.unitId)];
                          getUnitDetail();
                          handleChange(customInputEvent('unitId', $form.unitId));
                        },
                      });
                      setTimeout(() => {
                        selectedUnitId = units[searchKeyByValue(units, 'id', $form.unitId)];
                      }, 500);
                    } else if ($form.unitId != ev.detail.id) {
                      $form.unitId = ev.detail.id;
                      getUnitDetail();
                      handleChange(customInputEvent('unitId', $form.unitId));
                    }
                  }}
                  optionIdentifier="id"
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                ></Select>
                {#if $errors.unitId}
                  <label class="formError">
                    {$errors.unitId}
                  </label>
                {/if}
              </div>
              {#if editTask == false && $form.unitId > 0}
                <!-- <div class="d-flex justify-content-end mx-1">
				<button type="button" on:click={()=>selectFromTemplate($form.unitId,$form.taskType,$form.clients,$form.unitProjectId)} class="btn-link btn mb-0 font-size-13 color-blue shadow-none border-0 bg-transparent p-0 ">
				  Select from Templates
				</button>
				</div> -->
              {/if}
            </div>

            <!-- Select Service Type select -->
            <div
              class="form-group select-block select-client-type me-2 business-template position-relative {$errors.unitId
                ? 'error'
                : ''}"
            >
              <Select
                showChevron={true}
                isClearable={true}
                bind:selectedValue={selectedServiceTypeId}
                placeholder="Select Service Type"
                items={taskServiceType}
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                optionIdentifier="id"
                getOptionLabel={(option) => {
                  return option.name;
                }}
                containerClasses="form-control"
                on:select={(ev) => {
                  $form.taskServiceTypeId = ev.detail.id;
                }}
                on:clear={() => {
                  $form.taskServiceTypeId = null;
                }}
              ></Select>
              {#if $errors.taskServiceTypeId}
                <label
                  for=""
                  class="formError"
                >
                  {$errors.taskServiceTypeId}
                </label>
              {/if}
            </div>

            <div
              class="form-group select-block select-client-type me-2 business-activity-template d-flex flex-row assignee-select position-relative {$errors.assigneeUserId
                ? 'error'
                : ''}"
            >
              <!-- <ProfileImg size={35} photoUrl={photoUrl} className="d-inline-block align-middle me-1" /> -->
              <svg
                class="me-1"
                width="16"
                height="16"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M6.875 4.125V2.75H11V4.125H6.875ZM12.375 2.75H20.625V4.125H12.375V2.75ZM0 6.875V1.375H5.5V6.875H0ZM1.375 2.75V5.5H4.125V2.75H1.375ZM6.875 11V9.625H11V11H6.875ZM12.375 11V9.625H20.625V11H12.375ZM0 13.75V8.25H5.5V13.75H0ZM1.375 9.625V12.375H4.125V9.625H1.375ZM6.875 17.875V16.5H11V17.875H6.875ZM12.375 17.875V16.5H20.625V17.875H12.375ZM0 20.625V15.125H5.5V20.625H0ZM1.375 16.5V19.25H4.125V16.5H1.375Z"
                  fill=""
                /></svg
              >
              <Select
                showChevron={true}
                isClearable={true}
                bind:selectedValue={selectedTaskActivityTypeId}
                placeholder="Select Activity Type"
                items={taskActivityTypes}
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                optionIdentifier="id"
                getOptionLabel={(option) => {
                  return option.name;
                }}
                containerClasses="form-control"
                on:select={(ev) => {
                  $form.taskActivityTypeId = ev.detail.id;
                  handleChange(customInputEvent('taskActivityTypeId', $form.taskActivityTypeId));
                }}
                on:clear={(ev) => {
                  $form.taskActivityTypeId = null;
                  handleChange(customInputEvent('taskActivityTypeId', $form.taskActivityTypeId));
                }}
              ></Select>
              {#if $errors.taskActivityTypeId}
                <label
                  for=""
                  class="formError"
                >
                  {$errors.taskActivityTypeId}
                </label>
              {/if}
            </div>

            <div
              class="form-group select-block select-client-type business-template d-flex flex-row assignee-select position-relative {$errors.assigneeUserId
                ? 'error'
                : ''}"
            >
              <!-- <ProfileImg size={35} photoUrl={photoUrl} className="d-inline-block align-middle me-1" /> -->
              <svg
                width="25"
                height="25"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M99.707 78.125L81.8848 95.9473L77.4902 91.5527L87.793 81.25H56.25V75H87.793L77.4902 64.6973L81.8848 60.3027L99.707 78.125ZM65.9668 68.457C64.6973 65.6576 63.0859 63.1348 61.1328 60.8887C59.1797 58.6426 56.9499 56.7057 54.4434 55.0781C51.9368 53.4505 49.2676 52.1973 46.4355 51.3184C43.6035 50.4395 40.625 50 37.5 50C34.6354 50 31.8685 50.3743 29.1992 51.123C26.5299 51.8717 24.0397 52.9134 21.7285 54.248C19.4173 55.5827 17.3177 57.2103 15.4297 59.1309C13.5417 61.0514 11.9141 63.1673 10.5469 65.4785C9.17969 67.7897 8.12174 70.2799 7.37305 72.9492C6.62435 75.6185 6.25 78.3854 6.25 81.25H0C0 77.4414 0.569661 73.7142 1.70898 70.0684C2.84831 66.4225 4.49219 63.0534 6.64062 59.9609C8.78906 56.8685 11.3444 54.1178 14.3066 51.709C17.2689 49.3001 20.5729 47.4609 24.2188 46.1914C22.3958 45.0195 20.7682 43.6686 19.3359 42.1387C17.9036 40.6087 16.6667 38.9323 15.625 37.1094C14.5833 35.2865 13.8184 33.3659 13.3301 31.3477C12.8418 29.3294 12.5651 27.2135 12.5 25C12.5 21.5495 13.151 18.3105 14.4531 15.2832C15.7552 12.2559 17.5293 9.60286 19.7754 7.32422C22.0215 5.04557 24.6745 3.25521 27.7344 1.95312C30.7943 0.651042 34.0495 0 37.5 0C40.9505 0 44.1895 0.651042 47.2168 1.95312C50.2441 3.25521 52.8971 5.0293 55.1758 7.27539C57.4544 9.52148 59.2448 12.1745 60.5469 15.2344C61.849 18.2943 62.5 21.5495 62.5 25C62.5 29.4596 61.4746 33.4961 59.4238 37.1094C57.373 40.7227 54.4922 43.75 50.7812 46.1914C53.125 47.0703 55.3385 48.1608 57.4219 49.4629C59.5052 50.765 61.4258 52.2624 63.1836 53.9551C64.9414 55.6478 66.5365 57.5033 67.9688 59.5215C69.401 61.5397 70.638 63.6719 71.6797 65.918L65.9668 68.457ZM18.75 25C18.75 27.6042 19.2383 30.0293 20.2148 32.2754C21.1914 34.5215 22.526 36.5072 24.2188 38.2324C25.9115 39.9577 27.8971 41.3086 30.1758 42.2852C32.4544 43.2617 34.8958 43.75 37.5 43.75C40.0716 43.75 42.4967 43.2617 44.7754 42.2852C47.054 41.3086 49.0397 39.974 50.7324 38.2812C52.4251 36.5885 53.776 34.6029 54.7852 32.3242C55.7943 30.0456 56.2826 27.6042 56.25 25C56.25 22.4284 55.7617 20.0033 54.7852 17.7246C53.8086 15.446 52.474 13.4603 50.7812 11.7676C49.0885 10.0749 47.0866 8.72396 44.7754 7.71484C42.4642 6.70573 40.0391 6.21745 37.5 6.25C34.8958 6.25 32.4707 6.73828 30.2246 7.71484C27.9785 8.69141 25.9928 10.026 24.2676 11.7188C22.5423 13.4115 21.1914 15.4134 20.2148 17.7246C19.2383 20.0358 18.75 22.4609 18.75 25Z"
                  fill=""
                /></svg
              >
              <Select
                showChevron={true}
                isClearable={false}
                bind:selectedValue={selectedAssigneeUserId}
                placeholder="Select Assignee"
                items={unitUsers}
                getSelectionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                optionIdentifier="userId"
                getOptionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                containerClasses="form-control"
                on:select={(ev) => {
                  $form.assigneeUserId = ev.detail.userId;
                  handleChange(customInputEvent('assigneeUserId', $form.assigneeUserId));
                }}
              ></Select>
              {#if $errors.assigneeUserId}
                <label
                  for=""
                  class="formError"
                >
                  {$errors.assigneeUserId}
                </label>
              {/if}
            </div>
          </div>
        </div>
      </div>
      <!-- {#if $form.collabratorReviewStatus==1 || $form.collabratorReviewStatus==2}
			  <div class="mt-0 p-3 d-flex flex-column position-relative {$errors.collabratorUserId?"error":""}">
				  <div class="me-2"><label for="" class="form-label">Select Collaborators</label></div>
				  <div class="w-100 multi-select">
					<Select
					  showChevron={true}
					  isClearable={true}
					  isDisabled={taskCompleted || oldCollabratorReviewStatus!=0}
					  bind:selectedValue={selectedCollabratorUsers}
					  on:select={(ev)=>{
						$form.collabratorUserId=ev.detail.userId
						handleChange(customInputEvent('collabratorUserId', $form.collabratorUserId));
					  }}
					  containerClasses="form-control"
					  getSelectionLabel={(option) =>{
						return option.firstName + " " + option.lastName
					  }}
					  optionIdentifier={"userId"}
					  getOptionLabel={(option) =>{
						return option.firstName + " " + option.lastName
					  }}
					  items={selectedUsers}
					></Select>
				  {#if $errors.collabratorUserId}
					<label alt="" for="" class="formError">
					  {$errors.collabratorUserId}
					</label>
				  {/if}
				  </div>
			  </div>


			  <div class="p-3 pt-0 pb-0 bg-white rounded box-shadow">

						<FormTextarea disabled={taskCompleted || oldCollabratorReviewStatus!=0} label="Collaborator Notes"  placeholder="Enter Notes..."
						{handleChange} error={$errors.collabratorSubmitNotes} name="collabratorSubmitNotes"
						bind:value={$form.collabratorSubmitNotes} />

			  </div>
			{/if}
			{#if $form.collabratorReviewStatus==2}
			  <div class=" mt-0 p-3 pt-0 pb-0 bg-white rounded box-shadow">

						<FormTextarea disabled={taskCompleted || oldCollabratorReviewStatus==2} label="Collaborator Review Back Notes" placeholder="Enter Notes..."
						{handleChange} error={$errors.collabratorReviewNotes} name="collabratorReviewNotes"
						bind:value={$form.collabratorReviewNotes} />

			  </div>
			{/if} -->

      <div class="modal-form-area form-input-area border-0 pt-0">
        <div class="form-group mb-3 position-relative">
          <div class="d-flex flex-row justify-content-between align-items-center mb-1">
            <label
              for="name"
              class="form-label mb-0">Task</label
            >
            <!-- Priority dropdown change on Edit -->
            {#if editTask == true}
              <div class="position-relative d-flex justify-content-end">
                <span class="d-inline-block align-middle me-3 mt-2">Priority:</span>
                <DropDown
                  showIcon={true}
                  checkbox={false}
                  deleteSelected={false}
                  active={true}
                  titleChanged={true}
                  extraClass={getValueBySearchValue(
                    configItem.priority,
                    'id',
                    $form.priority,
                    'extraClass',
                  )}
                  icon={getValueBySearchValue(configItem.priority, 'id', $form.priority, 'icon')}
                  title={getValueBySearchValue(configItem.priority, 'id', $form.priority, 'name')}
                  defaultTitle="Priority"
                  on:onSelect={(item) => {
                    $form.priority = item.detail.id;
                  }}
                  option={configItem.priority}
                  Style="select-block priority-dropdown"
                />
                <!-- Risk Rank dropdown change on Edit -->
                <span class="d-inline-block align-middle mx-3 mt-2">Risk Rank:</span>
                <DropDown
                  showIcon={true}
                  checkbox={false}
                  deleteSelected={false}
                  active={true}
                  titleChanged={true}
                  extraClass={getValueBySearchValue(
                    configItem.riskRank,
                    'id',
                    $form.riskRank,
                    'extraClass',
                  )}
                  icon={getValueBySearchValue(configItem.riskRank, 'id', $form.riskRank, 'icon')}
                  title={getValueBySearchValue(configItem.riskRank, 'id', $form.riskRank, 'name')}
                  defaultTitle="Risk Rank"
                  on:onSelect={(item) => {
                    $form.riskRank = item.detail.id;
                  }}
                  option={configItem.riskRank}
                  Style="select-block risk-rank-dropdown"
                />
              </div>
            {/if}
          </div>

          <FormInput
            maxLength={configItem.maxLength.input}
            disabled={templateSelected || (id > 0 && editSubTask == false)}
            placeholder="Enter Task"
            handleChange={handleChange}
            error={$errors.name}
            name="name"
            bind:value={$form.name}
          />
        </div>
        {#if editSubTask == false}
          <FormTextarea
            label="Purpose"
            maxLength={configItem.maxLength.textarea}
            disabled={templateSelected || id > 0}
            placeholder="Enter Purpose..."
            handleChange={handleChange}
            error={$errors.purpose}
            name="purpose"
            bind:value={$form.purpose}
          />
          <FormTextarea
            label="Requirement"
            maxLength={configItem.maxLength.textarea}
            disabled={templateSelected || id > 0}
            placeholder="Enter Requirement..."
            handleChange={handleChange}
            error={$errors.requirement}
            name="requirement"
            bind:value={$form.requirement}
          />
        {/if}

        <FormTextarea
          Style="height:100px"
          label="Short Description"
          maxLength={configItem.maxLength.description}
          disabled={templateSelected}
          placeholder="Enter Short Description..."
          handleChange={handleChange}
          error={$errors.description}
          name="description"
          bind:value={$form.description}
        />

        <FormTextarea
          label="Notes for Client"
          maxLength={configItem.maxLength.description}
          placeholder="Enter Notes for Client..."
          handleChange={handleChange}
          error={$errors.clientNotes}
          name="clientNotes"
          bind:value={$form.clientNotes}
          Style="height:100px"
        />

        {#if editSubTask == false}
          <div class="row">
            <div class="col-md-5">
              <div class="form-label mb-2">
                <div class="checkbox c-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="requireReview"
                      disabled={taskCompleted}
                      checked={$form.requireReview == 1}
                      on:change={(event) => ($form.requireReview = event.target.checked ? 1 : 0)}
                    />
                    <span class="check-img" />
                    Requires Collaborator Review
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              {#if $form.taskType == 1}
                <div class="d-flex flex-row align-items-end position-relative justify-content-end">
                  <div class="me-2">
                    <label
                      for=""
                      class="text-nowrap form-label mb-0"
                    >
                      Responsible Party:
                    </label>
                  </div>
                  <div class="form-label mb-0 me-2">
                    <div class="radio c-radio">
                      <label class="text-nowrap">
                        <input
                          type="radio"
                          name="responsibleParty"
                          value="1"
                          checked={$form.responsibleParty == 1}
                          on:change={(event) => {
                            $form.responsibleParty = 1;
                            handleChange(event);
                          }}
                        />
                        <span class="check-img-blue" />
                        {getResposiblePartyLabel('unit', $form)}
                      </label>
                    </div>
                  </div>

                  <div class="form-label mb-0 me-0">
                    <div class="radio c-radio">
                      <label class="text-nowrap">
                        <input
                          type="radio"
                          name="responsibleParty"
                          value="2"
                          checked={$form.responsibleParty == 2}
                          on:change={(event) => {
                            $form.responsibleParty = 2;
                            handleChange(event);
                          }}
                        />
                        <span class="check-img-blue" />
                        <i
                          class="i_overflow"
                          title={getResposiblePartyLabel('client', $form)}
                          >{getResposiblePartyLabel('client', $form)}</i
                        >
                      </label>
                    </div>
                  </div>
                  {#if $errors.responsibleParty}
                    <label
                      class="formError"
                      for="responsibleParty"
                    >
                      {$errors.responsibleParty}
                    </label>
                  {/if}
                </div>
              {/if}
            </div>
          </div>
        {/if}
        <!-- Tabs Start -->
        <div class="tabs-block p-3">
          <div class="tabs-area bg-white">
            <div class="bg-white tabs-content-area">
              <div class="d-flex flex-row align-items-center justify-content-center">
                <div
                  class="btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    disabled={id > 0 ||
                      templateSelected == true ||
                      comeFrom == 'assignTask' ||
                      comeFrom == 'clone'}
                    on:click={() => {
                      if (!(id > 0) && templateSelected == false) $form.taskType = 1;
                    }}
                    class="btn font-size-12 tabber-btn d-flex flex-row shadow-none {$form.taskType ==
                    1
                      ? 'active'
                      : null}"
                  >
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                      ><g
                        ><g
                          ><path
                            d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148                            C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962                            c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216                            h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40                            c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                          /></g
                        ></g
                      ></svg
                    >
                    Client
                  </button>
                  <button
                    type="button"
                    disabled={id > 0 ||
                      templateSelected == true ||
                      comeFrom == 'assignTask' ||
                      comeFrom == 'clone'}
                    on:click={() => {
                      if (!(id > 0) && templateSelected == false && comeFrom != 'assignTask')
                        $form.taskType = 2;
                    }}
                    class="btn font-size-12 tabber-btn d-flex flex-row shadow-none {$form.taskType ==
                    2
                      ? 'active'
                      : null}"
                  >
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                      ><g
                        ><g
                          ><path
                            d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148                            C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962                            c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216                            h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40                            c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                          /></g
                        ></g
                      ></svg
                    >
                    Internal
                  </button>
                </div>
              </div>
              {#if $form.taskType == 1}
                <div class="row fade show">
                  {#if editTask == false && comeFrom != 'assignTask'}
                    <div class="row align-items-center mb-3">
                      <div class="col-md-4">
                        <label
                          for=""
                          class="form-label mb-0"
                        >
                          Client
                        </label>
                      </div>
                      <div class="col-md-7">
                        <div class="form-group position-relative {clientError ? 'error' : ''}">
                          <Select
                            bind:selectedValue={addClientlabel}
                            showChevron={true}
                            isClearable={true}
                            getSelectionLabel={(option) => {
                              return option.name;
                            }}
                            containerClasses="form-control"
                            on:select={(ev) => {
                              addClientlabel = ev.detail;
                              addClient();
                              setTimeout(() => {
                                addClientlabel = undefined;
                              }, 100);
                              clientError = false;
                            }}
                            optionIdentifier="id"
                            getOptionLabel={(option) => {
                              return option.name;
                            }}
                            items={clients}
                          ></Select>
                          {#if clientError}
                            <label
                              class="formError"
                              for="id"
                            >
                              Please add at least one client
                            </label>
                          {/if}
                        </div>
                      </div>
                      <!-- <div class="col-md-1">
							<button type="button" class="btn btn-link px-0 mb-0  shadow-none border-0 bg-transparent font-size-12" on:click={()=>{

							}}><img class="icon-10" alt="" src="/images/plus.svg" />  Add New</button>
						</div> -->
                    </div>
                  {/if}

                  <!-- <AddTaskClient  {clients} {client}/> -->
                  {#each $form.clients as item, key}
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group mb-3">
                          <label
                            for=""
                            class="form-label"
                          >
                            Client
                          </label>
                          <!-- isDisabled={id>0}               -->
                          <Select
                            showChevron={true}
                            isClearable={false}
                            containerClasses="form-label"
                            isDisabled={comeFrom != 'clone'}
                            bind:selectedValue={selectedClients[key].label}
                            getSelectionLabel={(option) => {
                              return option.name;
                            }}
                            on:select={(ev) => {
                              if ($form.clients[key].id != ev.detail.id) {
                                setTimeout(() => {
                                  selectedClients[key].clientFundProfiles = null;
                                  $form.clients[key].clientFundProfiles = null;
                                }, 100);
                              }
                              $form.clients[key].id = ev.detail.id;
                            }}
                            optionIdentifier="id"
                            getOptionLabel={(option) => {
                              return option.name;
                            }}
                            items={clients}
                          ></Select>
                          <a
                            style="margin-top: 0.5rem;"
                            href={'/client#action=viewClient&clientId=' + $form.clients[key].id}
                            target="_blank">View Client</a
                          >
                        </div>
                      </div>
                      <div class="col-md-7">
                        <div class="form-group mb-3">
                          <label
                            for=""
                            class="form-label"
                            >Client Sub-Profile/Funds:
                            {#if (comeFrom == 'clone' || comeFrom == 'assignTask') && $form.clients[key].clientFundProfiles && $form.clients[key].clientFundProfiles.length > 0}
                              <button
                                type="button"
                                class="bg-transparent border-0 add-btn m-0 p-0"
                                on:click={() => {
                                  selectedClients[key].clientFundProfiles = null;
                                }}
                                ><img
                                  class="icon-16"
                                  alt=""
                                  src="/images/pencil-gray.svg"
                                /></button
                              >
                            {/if}
                          </label>
                          <Select
                            showIndicator={true}
                            isClearable={false}
                            isDisabled={id > 0 ||
                              ((comeFrom == 'clone' || comeFrom == 'assignTask') &&
                                $form.clients[key].clientFundProfiles &&
                                $form.clients[key].clientFundProfiles.length > 0)}
                            isMulti={true}
                            bind:selectedValue={selectedClients[key].clientFundProfiles}
                            getSelectionLabel={(option) => {
                              return option.name;
                            }}
                            on:select={(ev) => {
                              $form.clients[key].clientFundProfiles = ev.detail;
                            }}
                            optionIdentifier="id"
                            getOptionLabel={(option) => {
                              return option.name;
                            }}
                            items={clientFundProfiles.filter((item) => {
                              return item.clientId == $form.clients[key].id;
                            })}
                          ></Select>
                        </div>
                      </div>
                      <div class="col-md-1">
                        {#if id == 0 && comeFrom != 'assignTask' && comeFrom != 'clone'}
                          <!-- {#if key==0}
							<button type="button" class="bg-transparent border-0 add-btn" on:click={()=>{
							  let oldClients=$form.clients
							  selectedClients.push({
								  "label": null,
								  "clientFundProfiles": null
							  });
							  oldClients.push({"id":"","clientFundProfiles":[]})
							  $form.clients=oldClients
							}}><img class="icon-16 " alt="" src="/images/plus.svg"></button>
						  {:else} -->
                          <button
                            type="button"
                            class="bg-transparent border-0 add-btn"
                            on:click={() => {
                              let oldClients = $form.clients;
                              let oldSelectedClients = selectedClients;
                              oldSelectedClients.splice(key, 1);
                              selectedClients = oldSelectedClients;
                              oldClients.splice(key, 1);
                              $form.clients = oldClients;
                              getUnitAssignee();
                            }}
                            ><img
                              class="icon-16"
                              alt=""
                              src="/images/cancel.svg"
                            /></button
                          >
                          <!-- {/if} -->
                        {/if}
                      </div>
                    </div>
                  {/each}
                </div>
              {/if}
              {#if $form.taskType == 2}
                <div class="row fade show">
                  <div class="col-md-4">
                    <div class="form-group select-block select-client-type mb-3">
                      <label
                        for=""
                        class="form-label">Project:</label
                      >
                      <Select
                        showChevron={true}
                        isClearable={true}
                        isDisabled={id > 0 || comeFrom == 'assignTask'}
                        placeholder="Select: Project One"
                        bind:selectedValue={selectedUnitProjectId}
                        items={projects}
                        on:select={(ev) => {
                          $form.unitProjectId = ev.detail.id;
                        }}
                        on:clear={(ev) => {
                          $form.unitProjectId = '';
                        }}
                        getSelectionLabel={(option) => {
                          return option.name;
                        }}
                        optionIdentifier="id"
                        getOptionLabel={(option) => {
                          return option.name;
                        }}
                      ></Select>
                    </div>
                  </div>
                </div>
              {/if}
            </div>
          </div>
        </div>
        <!-- Tabs End -->

        <div class="pt-3 pb-3">
          <div class="d-flex flex-row align-items-center justify-content-center">
            <div
              class="btn-group custom-button-group"
              role="group"
              aria-label="Basic example"
            >
              <button
                type="button"
                disabled={id > 0}
                on:click={() => {
                  if (!(id > 0)) $form.recurring = 1;
                }}
                class="btn font-size-12 tabber-btn align-items-center d-flex flex-row shadow-none {$form.recurring ==
                1
                  ? 'active'
                  : null}"
              >
                <svg
                  viewBox="0 0 64 64"
                  width="512"
                  height="512"
                  ><g id="Calendar"
                    ><path
                      d="M57,8H52V6a4,4,0,0,0-8,0V8H36V6a4,4,0,0,0-8,0V8H20V6a4,4,0,0,0-8,0V8H7a5,5,0,0,0-5,5V53a5,5,0,0,0,5,5H35a1,1,0,0,0,0-2H7a3.009,3.009,0,0,1-3-3V22H60V39a1,1,0,0,0,2,0V13A5,5,0,0,0,57,8ZM46,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM30,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM14,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM60,20H4V13a3.009,3.009,0,0,1,3-3h5v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h5a3.009,3.009,0,0,1,3,3Z"
                    /><path
                      d="M30,29a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z"
                    /><path
                      d="M18,29a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z"
                    /><path
                      d="M52,34a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2Zm-4-5h4v3H48Z"
                    /><path
                      d="M30,38a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z"
                    /><path
                      d="M18,38a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z"
                    /><path
                      d="M28,45H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,28,45Zm-4,5V47h4v3Z"
                    /><path
                      d="M36,34h4a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H36a2,2,0,0,0-2,2v3A2,2,0,0,0,36,34Zm0-5h4v3H36Z"
                    /><path
                      d="M34,41a2,2,0,0,0,2,2,1,1,0,0,0,0-2V38h4a1,1,0,0,0,0-2H36a2,2,0,0,0-2,2Z"
                    /><path
                      d="M16,45H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,16,45Zm-4,5V47h4v3Z"
                    /><path
                      d="M49,36A13,13,0,1,0,62,49,13.015,13.015,0,0,0,49,36Zm0,24A11,11,0,1,1,60,49,11.013,11.013,0,0,1,49,60Z"
                    /><path
                      d="M54.778,44.808,47,52.586,43.465,49.05a1,1,0,0,0-1.414,1.414l4.242,4.243a1,1,0,0,0,1.414,0l8.485-8.485a1,1,0,0,0-1.414-1.414Z"
                    /></g
                  ></svg
                >
                Recurring
              </button>
              <button
                type="button"
                disabled={id > 0}
                on:click={() => {
                  if (!(id > 0)) $form.recurring = 0;
                }}
                class="btn font-size-12 tabber-btn align-items-center d-flex flex-row shadow-none {$form.recurring ==
                0
                  ? 'active'
                  : null} "
              >
                <svg
                  viewBox="0 0 64 64"
                  width="512"
                  height="512"
                  ><g id="Calendar"
                    ><path
                      d="M57,8H52V6a4,4,0,0,0-8,0V8H36V6a4,4,0,0,0-8,0V8H20V6a4,4,0,0,0-8,0V8H7a5,5,0,0,0-5,5V53a5,5,0,0,0,5,5H35a1,1,0,0,0,0-2H7a3.009,3.009,0,0,1-3-3V22H60V39a1,1,0,0,0,2,0V13A5,5,0,0,0,57,8ZM46,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM30,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM14,6a2,2,0,0,1,4,0v6a2,2,0,0,1-4,0ZM60,20H4V13a3.009,3.009,0,0,1,3-3h5v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h8v2a4,4,0,0,0,8,0V10h5a3.009,3.009,0,0,1,3,3Z"
                    /><path
                      d="M30,29a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z"
                    /><path
                      d="M18,29a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V29h4v3Z"
                    /><path
                      d="M52,34a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H48a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2Zm-4-5h4v3H48Z"
                    /><path
                      d="M30,38a2,2,0,0,0-2-2H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z"
                    /><path
                      d="M18,38a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2Zm-6,3V38h4v3Z"
                    /><path
                      d="M28,45H24a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,28,45Zm-4,5V47h4v3Z"
                    /><path
                      d="M36,34h4a2,2,0,0,0,2-2V29a2,2,0,0,0-2-2H36a2,2,0,0,0-2,2v3A2,2,0,0,0,36,34Zm0-5h4v3H36Z"
                    /><path
                      d="M34,41a2,2,0,0,0,2,2,1,1,0,0,0,0-2V38h4a1,1,0,0,0,0-2H36a2,2,0,0,0-2,2Z"
                    /><path
                      d="M16,45H12a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V47A2,2,0,0,0,16,45Zm-4,5V47h4v3Z"
                    /><path
                      d="M49,36A13,13,0,1,0,62,49,13.015,13.015,0,0,0,49,36Zm0,24A11,11,0,1,1,60,49,11.013,11.013,0,0,1,49,60Z"
                    /><path
                      d="M54.778,44.808,47,52.586,43.465,49.05a1,1,0,0,0-1.414,1.414l4.242,4.243a1,1,0,0,0,1.414,0l8.485-8.485a1,1,0,0,0-1.414-1.414Z"
                    /></g
                  ></svg
                >
                As occurs
              </button>
            </div>
          </div>
        </div>
        <div class="date-picker-calendar">
          <div class="d-flex flex-row mb-3">
            <DatePicker
              disabled={$form.parentId > 0}
              Style="active   me-1 calendar-input-block"
              placeholder="Open Date"
              on:change={(value) => {
                $form.openDate = value.detail[1];
                handleChange(customInputEvent('openDate', value.detail[1]));
              }}
              value={$form.openDate}
              error={$errors.openDate}
              name="openDate"
            />
            <DatePicker
              Style="  calendar-input-block"
              placeholder="Due Date"
              on:change={(value) => {
                $form.dueDate = value.detail[1];
                handleChange(customInputEvent('dueDate', value.detail[1]));
              }}
              value={$form.dueDate}
              error={$errors.dueDate}
              name="dueDate"
            />
            <!-- Initial Board Date field - show in the Edit Task mode only and not in the Scheduled task-->
            {#if editTask == true && $form.isSchedule == 0}
              <DatePicker
                Style="calendar-initial-board ms-5"
                placeholder="Initial Board Date"
                on:change={(value) => {
                  $form.initialBoardDate = value.detail[1];
                }}
                value={$form.initialBoardDate}
                error={$errors.initialBoardDate}
                name="initialBoardDate"
              />
            {/if}
          </div>
        </div>
        {#if $form.recurring == 1}
          <div class="row align-items-center mb-3">
            {#each recurringTypes as item}
              <div class="col mb-3">
                <div class="form-label mb-0">
                  <div class="radio c-radio">
                    <label>
                      <input
                        type="radio"
                        name="recurringType"
                        disabled={editSubTask}
                        checked={$form.recurringType == item.id && $form.recurringCustom == 0}
                        on:change={(event) => {
                          $form.recurringType = item.id;
                          $form.recurringCustom = 0;
                          handleChange(customInputEvent('recurringType', $form.recurringType));
                        }}
                      />
                      <span class="check-img-blue" />
                      {item.name}
                    </label>
                  </div>
                </div>
              </div>
            {/each}

            <div class="col mb-3">
              <div class="form-label mb-0">
                <div class="radio c-radio">
                  <label class="text-nowrap">
                    <input
                      checked={$form.recurringCustom == 1}
                      on:change={(event) => {
                        $form.recurringType = '';
                        $form.recurringCustom = 1;
                      }}
                      disabled={editSubTask}
                      type="radio"
                      name="Custom"
                      value="5"
                    />
                    <span class="check-img-blue" />
                    Custom
                  </label>
                </div>
              </div>
            </div>
            {#if $form.recurringCustom == 1}
              <div class="col-md-12">
                <div class="row">
                  <div class="col-mt-6">
                    <label
                      for=""
                      class="text-nowrap form-label">Repeat Every</label
                    >
                    <div class="d-flex flex-row">
                      <div class="">
                        <div class="me-2">
                          <FormInput
                            inputStyle="recuring-every-input"
                            disabled={editSubTask}
                            name="recurringEvery"
                            keypress={(e) => numberOnly(e)}
                            label=""
                            type="number"
                            max="50"
                            placeholder="Every"
                            handleChange={handleChange}
                            error={$errors.recurringEvery}
                            bind:value={$form.recurringEvery}
                          />
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div
                          style="z-index:99999"
                          class="form-group mb-3 select-block select-client-type d-flex flex-column position-relative {$errors.recurringType
                            ? 'error'
                            : ''}"
                        >
                          <Select
                            bind:selectedValue={selectedRecurringType}
                            isDisabled={editSubTask}
                            showChevron={true}
                            isClearable={true}
                            items={customRecurringTypes}
                            placeholder="Select Recurring Type"
                            getSelectionLabel={(option) => {
                              return option.name;
                            }}
                            containerClasses="form-control"
                            on:select={(ev) => {
                              $form.recurringType = ev.detail.id;
                              handleChange(customInputEvent('recurringType', $form.recurringType));
                            }}
                            optionIdentifier="id"
                            getOptionLabel={(option) => {
                              return option.name;
                            }}
                          ></Select>
                          {#if $errors.recurringType}
                            <label class="formError">
                              {$errors.recurringType}
                            </label>
                          {/if}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {:else}
              <div class="col-md-12">
                <div class="row">
                  <div class="col-mt-6 position-relative">
                    {#if $errors.recurringType}
                      <label class="formError">
                        {$errors.recurringType}
                      </label>
                    {/if}
                  </div>
                </div>
              </div>
            {/if}
          </div>
        {/if}
        {#if editSubTask == false}
          <div class="add-sub-task tabs-block p-3">
            <div class="tabs-area bg-white">
              <div class="bg-white tabs-content-area">
                <button
                  type="button"
                  on:click={addSubTask}
                  disabled={taskCompleted}
                  class="d-flex flex-row bg-transparent border-0 rounded mb-0 cursor add-subtask"
                >
                  + Add subtask
                </button>
                {#each $form.subTasks.filter((item) => {
                  return item.deleted == undefined;
                }) as item, key (item)}
                  <div
                    class="d-flex flex-row align-items-center add-task-input"
                    animate:flip
                    draggable={false}
                    on:dragstart={(event) => dragstart(event, key)}
                    on:drop|preventDefault={(event) => drop(event, key)}
                    ondragover="return false"
                    on:dragenter={() => (hovering = key)}
                    class:is-active={hovering === key}
                  >
                    <img
                      draggable={true}
                      class="btn-drag me-1"
                      alt=""
                      src="/images/drag-icon.svg"
                    />

                    {#if editTask}
                      <div class="checkbox-block">
                        <div class="checkbox c-checkbox">
                          <label class="">
                            <input
                              type="checkbox"
                              name="Change_Assign"
                              disabled={item.isNa == 1 || taskCompleted}
                              value="1"
                              checked={$form.subTasks[key].status == 2}
                              on:change={(e) =>
                                ($form.subTasks[key].status = e.target.checked ? 2 : 1)}
                            />
                            <span class="check-img" />
                          </label>
                        </div>
                      </div>
                    {/if}
                    <div
                      class="w-100 position-relative input-subtask {$errors.subTasks != undefined &&
                      $errors.subTasks[key] != undefined &&
                      $errors.subTasks[key].name
                        ? 'error'
                        : ''}"
                    >
                      <textarea
                        name={'subTasks[' + key + '][name]'}
                        on:change={handleChange}
                        disabled={(templateSelected == true && item.taskTemplateId != undefined) ||
                          taskCompleted}
                        bind:value={$form.subTasks[key].name}
                        on:load={(event) => {
                          // event.target.style.height=(event.target.scrollHeight>29?41:29)+"px";
                        }}
                        on:keyup={(event) => {
                          if (event.key == 'Enter' && event.target.value.trim() != '') {
                            addSubTask();
                          }
                        }}
                        on:keydown={(event) => {
                          autogrowTextarea(event.target);
                        }}
                        class="mb-0 w-100 border-top-0 border-end-0 border-start-0 sub-task-input ms-2 {item.isNa !=
                          undefined && item.isNa != 0
                          ? 'text-decoration-line-through'
                          : ''}"
                        placeholder="Subtask Name"
                        maxLength={configItem.maxLength.input}
                        type="text"
                      />
                      <div class="hover-btn dd-none position-absolute">
                        {#if $form.subTasks[key].name.length > 0}
                          <span
                            class="text-length"
                            style="font-size: 10px;"
                            >{$form.subTasks[key].name.length}/{configItem.maxLength.input}</span
                          >
                        {/if}
                        {#if editTask && item.isNa == 0 && item.id > 0}
                          <button
                            type="button"
                            class="btn btn-link mr-0 p-0 shadow-none border-0 shadow-none bg-transparent"
                            on:click={() => {
                              show(item.id);
                            }}
                          >
                            <img
                              class="btn-applicable"
                              alt=""
                              src="/images/view-icon.svg"
                            />
                          </button>
                        {/if}
                        {#if !($form.subTasks[key].assigneeUserId != undefined && $form.subTasks[key].assigneeUserId > 0)}
                          <button
                            data-bs-placement="top"
                            data-bs-toggle="popover"
                            data-bs-trigger="hover"
                            data-bs-content={item.isNa == 0
                              ? 'Click here to mark the sub task as not applicable.'
                              : 'Click here to mark the sub task as applicable'}
                            type="button"
                            class="btn btn-link mr-0 p-0 shadow-none border-0 shadow-none bg-transparent subtask_popover"
                            on:click={(e) => {
                              removeAllTooltip();
                              setTimeout(() => (item.isNa = item.isNa == 1 ? 0 : 1), 100);
                            }}
                          >
                            {#if item.isNa == 1}
                              <img
                                class="btn-applicable"
                                alt=""
                                src="/images/task-applicable.svg"
                              />
                            {:else}
                              <img
                                class="btn-applicable"
                                alt=""
                                src="/images/task-not-applicable.svg"
                              />
                            {/if}
                          </button>
                        {/if}
                        {#if item.isNa == 0}
                          <button
                            type="button"
                            on:click={() =>
                              (item.show = item.show != undefined && item.show == 1 ? 0 : 1)}
                            class="btn btn-add-subtask-user mr-0 p-0 border-0 bg-transparent shadow-none position-relative border-0 shadow-none"
                          >
                            {#if $form.subTasks[key].selectedAssigneeUserId}
                              <span
                                style="    font-size: 10px;letter-spacing: -1px;float: left;text-align: center;width: 21px;"
                                title={$form.subTasks[key].selectedAssigneeUserId.firstName +
                                  ' ' +
                                  $form.subTasks[key].selectedAssigneeUserId.lastName}
                              >
                                {$form.subTasks[key].selectedAssigneeUserId.firstName
                                  .toString()
                                  .substr(0, 1)
                                  .toUpperCase()}
                                {$form.subTasks[key].selectedAssigneeUserId.lastName
                                  .toString()
                                  .substr(0, 1)
                                  .toUpperCase()}
                              </span>
                            {:else}
                              <img
                                class="btn-cancel icon-10"
                                alt=""
                                src="/images/user-dark.svg"
                              />
                            {/if}
                          </button>
                          <div
                            style="right: 0;width: 175px;z-index: 100000;"
                            class="collapse collapse-user position-absolute {item.show !=
                              undefined && item.show == 1
                              ? 'show'
                              : ''}"
                          >
                            <div class="card card-body p-2">
                              <Select
                                bind:selectedValue={$form.subTasks[key].selectedAssigneeUserId}
                                placeholder="Select Assignee"
                                items={unitUsers}
                                showChevron={true}
                                isClearable={false}
                                getSelectionLabel={(option) => {
                                  return option.firstName + ' ' + option.lastName;
                                }}
                                optionIdentifier="userId"
                                getOptionLabel={(option) => {
                                  return option.firstName + ' ' + option.lastName;
                                }}
                                containerClasses="form-control"
                                on:select={(ev) => {
                                  $form.subTasks[key].assigneeUserId = ev.detail.userId;
                                  item.show = 0;
                                }}
                              ></Select>
                            </div>
                          </div>
                          {#if !(item.taskTemplateId > 0)}
                            <button
                              type="button"
                              class="btn btn-link mr-0 p-0 shadow-none border-0 shadow-none bg-transparent"
                              on:click={() => {
                                showDialog({
                                  type: 'confirm',
                                  title: '',
                                  message: 'Are you sure ?',
                                  okFunc: () => {
                                    let oldSubTasks = $form.subTasks;
                                    oldSubTasks.splice(key, 1);
                                    $form.subTasks = oldSubTasks;
                                  },
                                });
                              }}
                            >
                              <img
                                class="btn-cancel"
                                alt=""
                                src="/images/cancel.svg"
                              />
                            </button>
                          {/if}
                        {/if}
                      </div>
                    </div>
                  </div>
                {/each}
              </div>
            </div>
          </div>
        {/if}
        <!-- Collobrated  -->
        <div class="collaborators-block position-relative w-100">
          <div class="d-flex flex-row align-items-center">
            <div class="me-2">
              <label
                for=""
                class="form-label mb-0">Collaborators:</label
              >
            </div>
            <div class="w-100 multi-select">
              <!-- <Select
					showChevron={true}
					isClearable={false}
					isMulti={true}
					isDisabled={taskCompleted || oldCollabratorReviewStatus!=0}
					bind:selectedValue={selectedUsers}
					on:select={(ev)=>{
					  $form.users=ev.detail!=null?ev.detail:[]
					}}
					getSelectionLabel={(option) =>{
					  return option.firstName + " " + option.lastName
					}}
					optionIdentifier={"userId"}
					getOptionLabel={(option) =>{
					  return option.firstName + " " + option.lastName
					}}
					items={collabratorUser}
				  ></Select> -->
              <Select
                showChevron={true}
                isClearable={false}
                isMulti={false}
                isDisabled={taskCompleted}
                bind:selectedValue={selectedUserLabel}
                on:select={(ev) => {
                  selectedUserLabel = ev.detail;
                  let arr = $form.users;
                  if (searchKeyByValue(arr, 'userId', selectedUserLabel.userId) !== -1) {
                    showDialog({
                      message: 'User already selected',
                    });
                  } else {
                    arr.push(selectedUserLabel);
                    $form.users = arr;
                    selectedUserLabel = null;
                  }
                  setTimeout(() => {
                    selectedUserLabel = undefined;
                  }, 100);
                }}
                getSelectionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                optionIdentifier="userId"
                getOptionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                items={collabratorUser}
              ></Select>
            </div>
          </div>
          <ul class="ul-list">
            {#each $form.users as item, i}
              <li class="form-group my-2 {item.active == 1 ? 'active' : 'inactive'} ">
                <div class="d-flex align-items-center">
                  <label
                    for=""
                    class="mb-0 form-label">{item.firstName} {item.lastName}</label
                  >
                  <button
                    type="button"
                    disabled={taskCompleted ||
                      (oldCollabratorReviewStatus != 0 &&
                        oldTaskData.collabratorUserId == item.userId)}
                    on:click={() => {
                      showDialog({
                        isDeleteModel: true,
                        type: 'confirm',
                        title: '',
                        message: 'Are you sure ?',
                        okFunc: () => {
                          let oldUsers = $form.users;
                          oldUsers.splice(i, 1);
                          $form.users = oldUsers;
                        },
                      });
                    }}
                    class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 close-button bg-transparent d-flex align-items-center justify-content-center"
                  >
                    <img
                      alt=""
                      class="icon-16"
                      src="/images/close.svg"
                    />
                  </button>
                </div>
              </li>
            {/each}
          </ul>
        </div>

        <!-- Collobrated  -->
        <hr class="hrline" />
        <!-- Sub Task Block -->
        <div class="row file-uploader-task">
          <div class="col-md-12">
            {#if isAjaxLoading == false}
              <div>
                <SimpleFileUploader
                  on:fileChanged={(event) => {
                    if (event.detail.type == 'add') {
                      $form.attachments.push(event.detail);
                    } else if (event.detail.type == 'delete') {
                      let index = searchKeyByValue(
                        $form.attachments,
                        'fileName',
                        event.detail.fileName,
                      );
                      if (index !== -1) {
                        $form.attachments.splice(index, 1);
                      }
                    } else if (event.detail.type == 'uploading') {
                      isFormPending = true;
                    } else if (event.detail.type == 'uploaded') {
                      isFormPending = false;
                    }
                  }}
                  photoUrl={displayfiles.filter((item) => {
                    return !(item.taskTemplateId != undefined && item.taskTemplateId > 0);
                  })}
                  allFileType={true}
                  allowMultiple={true}
                  requestFrom="task"
                  entityId={$form.id}
                />
                {#if displayfiles.filter((item) => {
                  return item.taskTemplateId != undefined && item.taskTemplateId > 0;
                }).length > 0}
                  <div class="filepreview-list-scroller">
                    <ul
                      class="filepreview-list"
                      role="list"
                    >
                      {#each displayfiles.filter((item) => {
                        return item.taskTemplateId != undefined && item.taskTemplateId > 0;
                      }) as file}
                        <li class="filepreview-item">
                          <div class="d-flex flex-row align-items-center">
                            <div>
                              <img
                                alt=""
                                src="/images/cross-gray.svg"
                              />
                            </div>
                            <a
                              href="#"
                              on:click|preventDefault={() =>
                                fileDownload(
                                  file.fileId,
                                  file.origionalName ? file.origionalName : file.fileName,
                                )}
                              ><span>{file.origionalName ? file.origionalName : file.fileName}</span
                              ></a
                            >
                          </div>
                        </li>
                      {/each}
                    </ul>
                  </div>
                {/if}
              </div>
            {/if}
            <!-- <Attachments/> -->

            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Links</label
              >
              <div class="d-flex flex-row position-relative">
                <div class="position-relative w-100 d-flex">
                  <div class="{urlInvalid != '' ? 'error' : ''} w-100 position-relative">
                    {#if urlInvalid != ''}
                      <label
                        class="formError"
                        for="example-text-input">{urlInvalid}</label
                      >
                    {/if}
                    <input
                      type="text"
                      class="form-control"
                      name="example-text-input"
                      placeholder="Enter URL"
                      on:change={() => (urlInvalid = '')}
                      on:keyup={(event) => {
                        if (event.key == 'Enter') {
                          addUrl();
                        }
                      }}
                      bind:value={newUrl}
                    />
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    name="example-text-input"
                    placeholder="Enter URL Title"
                    bind:value={newTitle}
                    on:keyup={(event) => {
                      if (event.key == 'Enter') {
                        addUrl();
                      }
                    }}
                    style="margin-left:5px"
                  />
                </div>
                <button
                  type="button"
                  disabled={taskCompleted}
                  class="btn background-blue mb-0 text-white px-4 add-task font-size-12 btn-primary ms-1"
                  on:click={addUrl}
                >
                  Add
                </button>
              </div>
            </div>
            <ul class="filte-upload font-size-13 mb-3">
              {#each $form.urls as item, key}
                <li class="d-flex flex-row align-items-center mb-1">
                  <img
                    class="icon-16 me-1"
                    alt=""
                    src="/images/globe.svg"
                  />
                  <span
                    ><a
                      href={item.url}
                      target="_blank">{item.title.trim() != '' ? item.title : item.url}</a
                    ></span
                  >
                  {#if !(templateSelected == true && item.taskTemplateId != undefined)}
                    <button
                      type="button"
                      disabled={taskCompleted}
                      class="close bg-transparent border-0 p-0 ms-2 mb-0"
                      on:click={() => {
                        let oldUrls = $form.urls;
                        oldUrls.splice(key, 1);
                        $form.urls = oldUrls;
                      }}
                    >
                      <img
                        alt=""
                        src="/images/cancel.svg"
                      />
                    </button>
                  {/if}
                </li>
              {/each}
            </ul>
          </div>
        </div>

        {#if editTask == true && $form.isSchedule == 0}
          <div class="form-group mb-3">
            <label
              for=""
              class="form-label">Select <span class="text-primary">Task Status</span></label
            >
            <div class="position-relative">
              <div class="form-group select-block me-1 d-flex flex-row w-100">
                <Select
                  containerStyles="width:100%"
                  isDisabled={/*$form.requireReview==1 &&*/ $form.collabratorReviewStatus == 1 &&
                    $form.collabratorUserId != getUserInfo().id}
                  showChevron={true}
                  isClearable={false}
                  bind:selectedValue={selectedStatus}
                  optionIdentifier="id"
                  on:select={(ev) => {
                    if (ev.detail.id == 15) {
                      $form.status = 1;
                      let errorMessage = '';
                      if ($form.users.length == 0) {
                        errorMessage = 'Please add collaborators first';
                      } else {
                        let oldIds = oldTaskData.users
                          .map((item) => {
                            return item.id;
                          })
                          .sort();
                        let newIds = $form.users
                          .map((item) => {
                            return item.id;
                          })
                          .sort();
                        if (JSON.stringify(newIds) != JSON.stringify(oldIds)) {
                          errorMessage = 'Please save collaborators first';
                        } else if (
                          oldTaskData.users.filter((item) => {
                            return item.active == 1;
                          }).length == 0
                        ) {
                          errorMessage =
                            'This task doesn’t contain an active collaborator, Please add and save a collaborator first';
                        }
                      }
                      if (errorMessage != '') {
                        showDialog({
                          message: errorMessage,
                        });
                        setTimeout(() => {
                          selectedStatus = status[searchKeyByValue(status, 'id', $form.status)];
                        }, 100);
                      } else {
                        taskCollabrationHistory.show();
                      }
                    } else if (ev.detail.id == 16) {
                      $form.status = 1;
                      taskCollabrationHistory.showReview();
                    } else {
                      $form.status = ev.detail.id;
                      if ($form.status == 2) {
                        $form.completeDate = getTodayDate();
                      }
                    }
                  }}
                  getSelectionLabel={(option) => {
                    return option.text;
                  }}
                  placeholder="Status"
                  items={status}
                  getOptionLabel={(option) => {
                    return option.text;
                  }}
                />
              </div>
            </div>
          </div>
          <!-- Compliance Status dropdown -->
          {#if editTask == true && $form.isSchedule == 0}
            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Select <span class="text-primary">Compliance Status</span></label
              >
              <div class="position-relative">
                <Select
                  showChevron={true}
                  isClearable={false}
                  containerClasses="form-control"
                  bind:selectedValue={selectComplianceStatus}
                  placeholder="Select Compliance Status"
                  items={configItem.allComplianceStatus}
                  optionIdentifier="id"
                  getSelectionLabel={(option) => option.name}
                  getOptionLabel={(option) => option.name}
                  on:select={(ev) => {
                    $form.complianceStatus = ev.detail.id;
                  }}
                ></Select>
              </div>
            </div>
          {/if}
          <!-- {#if taskCompleted==false && $form.users.length>0}
				{#if oldCollabratorReviewStatus==0}
				  {#if $form.collabratorReviewStatus==0}
					<button type="button" on:click={()=>{$form.collabratorReviewStatus=1}} class="btn btn-primary font-size-12 border-0 text-white">
					  <img class="icon-16 me-1" alt="" src="/images/submit-collaborator.svg" /> Submit To Collaborator
					</button>
				  {:else}
					<button type="button" on:click={()=>{$form.collabratorReviewStatus=0}} class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel  font-size-12">
					  Cancel
					</button>
				  {/if}
				{:else}
				  {#if oldCollabratorReviewStatus==1 && $form.collabratorUserId==getUserInfo().id}
					{#if $form.collabratorReviewStatus==1}
					  <button type="button" on:click={()=>{$form.collabratorReviewStatus=2}} class="btn btn-warning font-size-12 border-0 text-white">
						Review Back
					  </button>
					{:else}
					  <button type="button" on:click={()=>{$form.collabratorReviewStatus=1}} class="btn btn-danger font-size-12 border-0 text-white">
						Cancel
					  </button>
					{/if}
				  {/if}
				{/if}
				{/if}-->
        {/if}
        {#if editTask && !(comeFrom != undefined && comeFrom == 'clone') && isFormPending == false}
          <TaskUpdateReason
            bind:this={taskUpdateReason}
            form={form}
            errors={errors}
            handleChange={handleChange}
            oldTaskData={oldTaskData}
            handleSubmit={handleSubmit}
            handleReasonSubmit={handleReasonSubmit}
            cancelChanges={cancelChanges}
          />
        {/if}
        {#if editTask && $form.id > 0 /*&& $form.requireReview==1*/ && $form.users.length > 0}
          <TaskCollabrationHistory
            bind:this={taskCollabrationHistory}
            id={id}
            selectedUsers={selectedUsers}
            selectedCollabratorUsers={selectedCollabratorUsers}
            form={form}
            errors={errors}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isFormPending={isFormPending}
            handleReasonSubmit={handleReasonSubmit}
          />
        {/if}
      </div>
    </form>
  {/if}
</div>
<div class="modal-footer rounded-0">
  <div
    class="d-flex flex-row justify-content-between w-100
			  align-items-center"
  >
    <div>
      {#if editTask == true && $form.isNa == 0 && !($form.parentId > 0 && $form.taskTemplateId > 0) && (taskCompleted == false || showDeleteTask)}
        <button
          type="button"
          class="btn color-red font-size-12 border-0 bg-transparent shadow-none"
          on:click={() => {
            taskAction({
              isDeleteModel: true,
              type: 'deleteTask',
              id: id,
            });
          }}
        >
          <img
            alt=""
            class="icon-16 me-1 trash-icon"
            src="/images/trash.svg"
          />
          Delete This Task
        </button>
      {/if}
    </div>
    <div>
      <button
        type="button"
        color="primary"
        class="btn btn-primary shadow-none background-blue mb-0 text-white add-task px-4 font-size-12"
        on:click={handleSubmit}
        disabled={isFormPending}
      >
        {#if isFormPending}
          <Loader />
        {:else}
          <span class="color-white font-size-12 font-weight-400"> Save </span>
        {/if}
      </button>
    </div>
  </div>
</div>

<style lang="scss">
  i.i_overflow {
    font-style: normal;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
  }
  .filepreview-list-scroller {
    margin-bottom: 15px;
    margin-top: -17px;
    margin-left: 14px;
    ul {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .filepreview-item {
        margin-bottom: 7px;
        img {
          width: 11px;
        }
        a {
          color: $black-color;
          min-height: 17px;
          background-position: center left;
          padding: 0px 13px !important;
        }
        span {
          font-size: 12px;
          line-height: 1.2;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 740px;
          display: inline-block;
          overflow: hidden;
        }
        a {
          padding: 0.5625em;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }
  }
  .text-length {
    position: relative;
    top: 3px;
  }
  .btn-add-subtask-user {
    border: 1px dashed #cdd9e9 !important;
    border-radius: 50%;
    width: 23px;
    height: 23px;
    margin-right: 6px;
    margin-top: 4px;
    img {
      position: relative;
      top: -3px;
    }
  }

  .collaborators-block {
    padding-top: 20px;
  }
  .filte-upload {
    list-style: none;
    padding: 0px;
    margin: 0px;

    .close {
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  .custom-button-group {
    .tabber-btn {
      background-color: $silver-color;
      border: 1px solid $silver-color;
      padding: 6px 20px;

      &.active {
        background-color: $blue-color;
        color: $white-color;
        border: 1px solid $blue-color;
        svg {
          fill: $white-color;
        }
      }
      svg {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }

  .hrline {
    margin-left: -15px;
    margin-right: -15px;
    background: var(--border-color);
  }

  .input-subtask {
    textarea {
      padding-right: 125px;
      height: 30px;
      line-height: 29px;
      overflow: hidden;
      padding-top: 0;
      padding-bottom: 0;
    }
    input {
      padding-right: 125px;
    }
    img {
      width: 12px;
      height: 12px;
    }
    &:hover {
      .hover-btn {
        display: block !important;
      }
    }
    .hover-btn {
      right: 0px;
      top: 0px;
    }
  }
  .btn-applicable {
    height: auto !important;
    width: 20px !important;
    margin-top: 2px;
  }
  .icon-next {
    transform: rotate(180deg);
  }
  .sub-task-input {
    border-bottom: 1px solid #cdd9e9;
  }
</style>
